import React, { useState } from 'react'
import close from '../../assets/icons/close.svg'
import eye from '../../assets/icons/eye.svg'
import Label from './Label'
import { useDispatch, useSelector } from 'react-redux'
import { showFormError, updateFieldError, updateFieldValue } from '../../features/siswaSlice'
import { getKelas } from '../../features/kelasSlice'



function Form() {
    const dispatch = useDispatch()
    const { errors, nama, niy, password } = useSelector((state) => state.siswa)
    const [passwordShown, setPasswordShown] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        dispatch(updateFieldValue({ field: name, value }));

        if (value.trim() !== '') {
            dispatch(updateFieldError({
                field: name,
                error: ''
            }))
        }

        dispatch(showFormError(name))
    };

    function handleDeleteInput() {
        dispatch(updateFieldValue({ field: 'nama', value: '' }));
    }

    function handleUnhide() {
        setPasswordShown(passwordShown ? false : true);
    }

    return (
        <div className='form'>
            <div className='nama'>
                <Label className='nama' label='Nama lengkap' />
                <input
                    type="text"
                    name="nama"
                    value={nama}
                    placeholder='Masukkan nama karyawan'
                    id='nama'
                    onChange={handleInputChange}
                />
                <p className='validator-text'>
                    {errors.nama && errors.nama}
                </p>
                <img src={close} onClick={handleDeleteInput} />
            </div>


            <div className='jabatan-gender'>
                <Label className='no-hp' label='Mapel' />
                {/*<KelasSelect />*/}
                <p className='validator-text'>
                    {errors.class_id && errors.class_id}
                </p>
            </div>

            <div className='jabatan-gender'>
                <Label className='no-hp' label='Kode Guru' />
                {/*<KelasSelect />*/}
                <p className='validator-text'>
                    {errors.class_id && errors.class_id}
                </p>
            </div>

            <div className='jabatan-gender'>
                <Label className='no-hp' label='Jadwal' />
                {/*<KelasSelect />*/}
                <p className='validator-text'>
                    {errors.class_id && errors.class_id}
                </p>
            </div>

        </div>
    )
}

export default Form